import { useAppDispatch } from "core/utils";
import { useParams } from "react-router";

import { ActionBar } from "../../../../../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../../../../../components/FeatureButtons/CancelButton";
import { OkButton } from "../../../../../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../../../../../components/Form/hooks/useFormSubmitTrigger";
import { ResourceName } from "../../../../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../../../../core/router/types/routerTypes";
import { setDefaultActiveKey } from "../../../../../../../../core/setup/redux/state/tabs/tabState";
import { CardAttributeCreateForm } from "../components/forms/CardAttributeCreateForm";

export const CardAttributeCreateFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk } = useFormSubmitTrigger();
    const { cardImplementationId, cardDefinitionId } = useParams();
    const backUrl = `${BASE_PATH}/${ResourceName.CARD_IMPLEMENTATIONS}/${cardImplementationId}/${ResourceName.CARD_DEFINITIONS}/${FORM_ACTION.EDIT}/${cardDefinitionId}`;

    const dispatch = useAppDispatch();
    const setTabsDefaultBeforeBack = () => dispatch(setDefaultActiveKey("card-implementations_cardAttributes"));

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.cardAttributesCreateFormPage" />
                <ActionBar>
                    <OkButton isDisabled={false} onClick={triggerOk} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <SubmitButton isDisabled={false} onClick={triggerSubmit} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <CancelButton isDisabled={false} url={backUrl} onBeforeNavigate={setTabsDefaultBeforeBack} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <CardAttributeCreateForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
